* {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
}

/*
 * Chrome paints autofilled inputs with its own blue background.
 * These variables are set from the theme on each field.
 */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active,
input:autofill,
textarea:autofill {
    -webkit-box-shadow: 0 0 0 1000px var(--input-bg) inset;
    box-shadow: 0 0 0 1000px var(--input-bg) inset;
    -webkit-text-fill-color: var(--input-color);
    caret-color: var(--input-color);
    transition: background-color 9999s ease-out 0s;
}

/* @media (min-resolution: 200dpi) {
    body {
         zoom: 85%;
    }
}

@media (min-resolution: 300dpi) {
    body {
         zoom: 70%;
    }
} */